import cardType from '@/modules/Dashboard/cardType'
const ROW_HEIGHT = 10
const MARGIN = 28
const CARD_WEEKS = cardType.CARD_WEEKS
const CARD_DATES = cardType.CARD_DATES
const CARD_PRODUCTS = cardType.CARD_PRODUCTS
const CARD_DATES_DETAIL = cardType.CARD_DATES_DETAIL
const SUMMARY_CARD_PRODUCTS = cardType.SUMMARY_CARD_PRODUCTS
const SUMMARY_CARD_REGIONS = cardType.SUMMARY_CARD_REGIONS
const SUMMARY_CARD_DATES = cardType.SUMMARY_CARD_DATES
const SUMMARY_CARD_WEEKS = cardType.SUMMARY_CARD_WEEKS

function useCardCollapse () {
    const tableRowHeight = {
        [CARD_WEEKS]: 5,
        [CARD_DATES]: 8,
        [CARD_PRODUCTS]: 7,
        [CARD_DATES_DETAIL]: 10,
        [SUMMARY_CARD_PRODUCTS]: 8,
        [SUMMARY_CARD_REGIONS]: 8,
        [SUMMARY_CARD_DATES]: 10,
        [SUMMARY_CARD_WEEKS]: 5
    }
    const getCollapseRow = ({ status, tableHeight }) => {
        const gridStyleObj = { rowHeight: ROW_HEIGHT, margin: MARGIN }
        const totalHeight = status ? tableHeight - gridStyleObj.margin : 0
        return (totalHeight + gridStyleObj.margin) / (gridStyleObj.rowHeight + gridStyleObj.margin)
    }
    const isFixedCard = (card, openedCard) => (
        card.y + card.h <= openedCard.y ||
        ((card.x + card.w) <= openedCard.x && card.y < (openedCard.y + openedCard.h))
    )
    const increaseOfOpenCardY = (layout, openedCard) => {
        let maxYH = 0
        for (let card of layout) {
            if (openedCard.i !== card.i && isFixedCard(card, openedCard)) {
                maxYH = Math.max(maxYH, card.y + card.h)
            }
        }
        return maxYH - openedCard.y
    }
    const increaseOfBelowCardY = (layout, openedCard) => {
        let minY = Infinity
        for (let card of layout) {
            if (openedCard.i !== card.i && !isFixedCard(card, openedCard)) {
                minY = Math.min(minY, card.y)
            }
        }
        return openedCard.y + tableRowHeight[openedCard.i] + openedCard.h - minY
    }

    const getLayoutsOfOpenedStatus = (layout, openCard) => {
        const newLayout = JSON.parse(JSON.stringify(layout))
        if (!tableRowHeight[openCard]) return newLayout
        if (!openCard) return newLayout
        let openedCardObj = newLayout.find(card => card.i === openCard)
        const openedY = increaseOfOpenCardY(newLayout, openedCardObj)
        const belowY = increaseOfBelowCardY(newLayout, openedCardObj)
        for (let card of newLayout) {
            if (openedCardObj.i !== card.i && !isFixedCard(card, openedCardObj)) {
                card.y += belowY + openedY
            }
        }
        openedCardObj.h += tableRowHeight[openCard]
        openedCardObj.y += openedY
        openedCardObj.x = 0
        openedCardObj.w = 24
        return newLayout
    }

    const getEveryLayoutsOfOpenedStatus = (initialLayout, openCardList) => {
        if (!initialLayout.length) return initialLayout
        const layoutObj = {}
        const n = openCardList.length
        for (let i = 0; i < (1 << n); i++) {
            const binaryString = i.toString(2).padStart(n, '0')
            layoutObj[binaryString] = getLayoutsOfOpenedStatus(initialLayout, null)
            for (let j = 0; j < n; j++) {
                if ((i & (1 << j))) {
                    layoutObj[binaryString] = getLayoutsOfOpenedStatus(layoutObj[binaryString], openCardList[j])
                }
            }
        }
        return layoutObj
    }

    return {
        getCollapseRow,
        getEveryLayoutsOfOpenedStatus,
        getLayoutsOfOpenedStatus
    }
}

export default useCardCollapse
